import { render, staticRenderFns } from "./SetTheme.vue?vue&type=template&id=2e7a6652&"
import script from "./SetTheme.vue?vue&type=script&lang=js&"
export * from "./SetTheme.vue?vue&type=script&lang=js&"
import style0 from "./SetTheme.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports